import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Navigate } from 'react-router';
import { PATH_AUTH, PATH_PAGE } from 'src/routes/paths';
import { userSelectors, workspaceSelectors } from 'src/selectors';
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import LoadingScreen from 'src/minimals/LoadingScreen';
import { setEmailedInvitation } from '../../redux/slices/invitations';
import { useIsUserRegistered } from 'src/gql/apiHooks/user';

export default function WorkspaceInvitationGuard({ children }) {
  const token = new URL(window.location.href).searchParams.get('token');
  const invitationToken = useSelector(workspaceSelectors.getInvitationToken());
  const isAuthenticated = useSelector(userSelectors.isAuth());
  const [isUserRegistered, { data }] = useIsUserRegistered();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!invitationToken) {
      try {
        if (token) {
          const tokenDecoded = jwtDecode(token);
          dispatch(setEmailedInvitation({ token, ...tokenDecoded }));
          isUserRegistered({ variables: { email: tokenDecoded.email } });
        } else {
          navigate('/');
        }
      } catch {
        navigate(PATH_PAGE.page500);
      }
    }
  }, [invitationToken, dispatch, navigate, token, isUserRegistered]);

  if (!invitationToken) return <LoadingScreen />;

  if (!isAuthenticated) {
    if (!data) {
      return <LoadingScreen />;
    }

    return (
      <Navigate
        to={data.isUserRegistered ? PATH_AUTH.login : PATH_AUTH.register}
      />
    );
  }

  return <>{children}</>;
}
